<template>
    <v-dialog
        @click:outside="initCloseModal(!showSMSInput)"
        :persistent="showSMSInput"
        v-model="showModal"
        max-width="800px"
        class=""
        content-class="scanning-app-modal"
    >
        <div class="scan-modal">
            <div class="close-btn" @click="initCloseModal(true)">
                <font-awesome-icon icon="fa-solid fa-times" class="fa-lg" />
            </div>
            <aside>
                <div class="content-wrapper">
                    <div class="content">
                        <h2 class="maintitle">Bring your photos to life</h2>
                        <p>Transform your physical photos into stunning digital memories in seconds</p>
                        <ul>
                            <li v-for="feature in features" :key="feature">{{ feature }}</li>
                        </ul>
                    </div>
                    <div class="social-proof">
                        <div class="user-block">JD</div>
                        <div class="user-block">KL</div>
                        <div class="user-block">MR</div>
                        100+ users love our app
                    </div>
                </div>
                <!-- floaty bits -->
                <div class="floaty-bit bit-1 animate-pulse"></div>
                <div class="floaty-bit bit-2 animate-pulse" style="animation-delay: 1s;"></div>
                <div class="floaty-bit bit-3 animate-pulse" style="animation-delay: 0.5s;"></div>
    
                <!-- Floating Photo Elements -->
                <div class="floaty-bit bit-4 animate-float" style="animation-delay: 0.2s;">
                    <div class="bit-wrap">
                        <div class="bit-inner"></div>
                    </div>
                    <div class="w-full h-1/4 bg-white rounded-b-md"></div>
                </div>
    
                <div class="absolute bottom-1/4 left-1/4 w-14 h-18 bg-white shadow-lg rounded-md transform -rotate-12 opacity-80 animate-float" style="animation-delay: 1.2s;">
                    <div class="bit-wrap">
                        <div class="w-full h-full bg-gradient-to-br from-yellow-200 to-orange-100"></div>
                    </div>
                    <div class="w-full h-1/4 bg-white rounded-b-md"></div>
                </div>
            </aside>
            <main>
                <div class="content my-4">
                    <div class="phone-icon-blob">
                        <font-awesome-icon icon="fa-solid fa-mobile" class="fa-lg" />
                    </div>
                    <h2 class="maintitle">Scan Physical Photos Using our Mobile App</h2>
                    <p>
                        Scan this QR code to download our app and start preserving your precious memories today.
                    </p>
                </div>
                <div class="qr-code" :class="{ 'h-hidden': showSMSInput, 'flex-grow-1': !showSMSInput }">
                    <qrcode-vue :value="shareLinkURL" size="150" class="image" />
                </div>
                <button class="cta" @click="showSMSInput = !showSMSInput;">
                    <font-awesome-icon icon="fa-regular fa-qrcode" class="fa-lg fa-fw mr-3" />
                    {{ !showSMSInput ? 'Text me the link' : 'Show me the QR Code'}}
                </button>

                <div class="sms-container d-flex flex-column" :class="{'h-hidden': !showSMSInput, 'flex-grow-1': showSMSInput}">
                    <div class="p-3 controls-header">
                        <p>Set your email or phone number below and we'll send you a link.</p>
                        <EmailSmsLink
                            ref="shareSMSInput"
                            @change="val => handleInvitesChange(val)"
                            @submit="sendLink"
                            :link="shareLinkURL"
                            v-if="showSMSInput && shareLinkURL"
                        >
                            <template #append-outer="{ submit, listLength }">
                                <v-btn
                                    style="background-color: rgba(251, 140, 0, 0.15); color: rgb(251, 140, 0)"
                                    @click="submit"
                                    depressed
                                    :disabled="!listLength || sending"
                                    >Send</v-btn
                                >
                            </template>
                        </EmailSmsLink>
                    </div>
                </div>
                <div class="ctas">
                    <a href="#" @click="close" v-if="showSkipLink">Skip</a>
                </div>
            </main>
        </div>
    </v-dialog>
</template>
<script>
import { mapActions } from 'vuex';
import QrcodeVue from 'qrcode.vue';
import EmailSmsLink from '../../ui/EmailSmsLink.vue';
import { debounceV2 } from '../../../utilities/debounce';
import TributeVideoService from '@/services/tributeVideo.service';
export default {
    data() {
        return {
            tributeApi: null,
            closeWithoutSavingModal: true,
            showModal: false,
            showSMSInput: false,
            showSkipLink: false,
            linkType: 'contributor',
            loading: false,
            sending: false,
            token: null,
            currentInvites: [],
            features: [
                'High-quality photo scanning',
                'Automatic edge detection',
                'Glare removal technology',
                'Instant cloud backup',
                'Share directly to social media'
            ],
            onCloseCallback: null

        };
    },
    inject: ['state'],
    components: { QrcodeVue, EmailSmsLink },
    computed: {
        disableUpdateBtn() {
            return this.hasChangesToSave || this.loading;
        },
        hasChangesToSave() {
            return false;
        },

        tributeVideo() {
            return this.$store.state.tributeVideo;
        },
        shareLinkURL() {
            if (this.linkType === 'family') {
                return this.tributeVideo.familyLink;
            }
            
            return this.tributeVideo.deeplink;
        }
    },
    watch: {
        showModal(newVal) {
            if (newVal) {
                this.getSettings();
            }
        },
    },
    methods: {
        ...mapActions(['showSnackbar']),
        openDefaultSettingsTab() {
            window.open(this.tributeDefaultSettingsLink, '_blank');
        },
        confirmCloseWithoutSaving() {
            this.closeWithoutSavingModal = false;
            this.close();
        },
        resetInput() {
            this.$refs?.shareSMSInput?.reset();
            this.showModal = false;
            this.onCloseCallback = null;
        },
        close() {
            if (this.onCloseCallback && typeof this.onCloseCallback === 'function') {
                console.log('')
                this.onCloseCallback();
            }
            this.showSkipLink = false;
            this.linkType = 'contributor';
            this.resetInput();
        },
        initCloseModal(skipConfirm) {
            if (skipConfirm) {
                this.close();
            } else {
                this.closeWithoutSavingModal = true;
            }
        },
        getSettings() {
            if (this.$refs.settings) {
                this.$refs.settings.getSettings();
            }
        },
        saveSettings() {
            if (this.$refs.settings) {
                this.$refs.settings.saveSettings();
            }
        },
        open() {
            this.showModal = true;
            sessionStorage.setItem(`${this.tributeVideo.serviceSlug}_scanModalShown`, true);
        },
        async setAuthToken() {
            if (this.state.token) {
                this.token = this.state.token;
            } else {
                const response = await this.$auth.getIdTokenClaims();
                this.token = response.__raw;
            }
        },
        handleInvitesChange(val) {
            this.currentInvites = val;
        },
        sendLink: debounceV2(function (formattedData) {
            this.sending = true;
            if (this.currentInvites.length) {
                // this.$root.$emit('handleShare', formattedData);
                this.handleInviteSubmit(formattedData);
                this.$nextTick(() => {
                    this.sending = false;
                    this.resetInput();
                });
            }
        }, 250),
        async handleInviteSubmit(contacts) {
            // console.log('Scan modal send invites');
            let data = {
                emailList: contacts.emailList.join(','),
                phoneList: contacts.phoneList.join(','),
                url: contacts.url,
            };

            try {
                await this.tributeApi.invite(this.tributeVideo.id, data);
                this.showSnackbar({ message: 'Invitations sent' });
            } catch (error) {
                console.log(error, 'error during invite submit');
                if (error?.response?.status === 401) {
                    this.showSnackbar({ message: 'Unauthorized access', color: 'error' });
                } else {
                    this.showSnackbar({ message: 'Error sending invitations', color: 'error' });
                }
            }
        },
    },
    async mounted() {
        this.setAuthToken();
        this.linkType = 'contributor';
        this.tributeApi = TributeVideoService(this.state.token);
        this.$root.$on('add-media-click', (callback) => {
            this.showSkipLink = true;
            if (!this.alreadyPromptedOnce) {
                this.alreadyPromptedOnce = true;
                this.onCloseCallback = callback;
                this.open();
            }
        });
        this.$root.$on('show-scan-modal', (linkType) => {
            this.linkType = linkType.toLowerCase();
            this.open();
        });
    },
    beforeUnmount() {
        this.$root.$off('add-media-click');
        this.$root.$off('show-scan-modal');
        this.showSkipLink = false;
    }
};
</script>
<style lang="scss" scoped>
.sticky-actions {
    position: sticky;
    bottom: 0;
    background-color: white;
    border-top: 1px solid #eee;
}
::v-deep {
    .scanning-app-modal {
        border-radius: 20px;
        overflow: hidden;
    }
}
.scan-modal {
    display: flex;
    background: white;
    height: 70vh;
    position: relative;
    
    .close-btn {
        position: absolute;
        top: 8px;
        right: 12px;
        opacity: 0.6;
        z-index: 10;
        cursor: pointer;
        &:hover {
            opacity: 1;
        }
    }
    .maintitle {
        font-weight: bolder;
        font-size: 1.9rem;
    }
    .phone-icon-blob {
        background: #fff2c8;
        color: $burnt-orange;
        width: 80px;
        aspect-ratio: 1;
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.5rem;
        margin: 0 auto;
    }
    aside, main {
        padding: 1rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    aside {
        background: #FF7300;
        background: linear-gradient(146deg, rgba(255, 115, 0, 1) 0%, rgba(255, 59, 0, 1) 100%);
        flex-basis: 40%;
        position: relative;

        .content-wrapper {
            position: absolute;
            inset: 0;
            padding: 1.5rem;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
        .content {
            color: white;
            font-weight: 600;
            padding: 1rem;

            li{
                line-height: 1.4;
                margin-bottom: 1.1rem;
            }
        }

        .social-proof {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 10pt;
            gap: 4px;
            font-weight: bold;
            color: white;

            .user-block {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 40px;
                aspect-ratio: 1;
                border-radius: 100%;
                border: 2px solid #fdf6f0;
                color: $brown-1;

                &:nth-child(1) {
                    background: lighten($yellow-2, 20%);
                }
                &:nth-child(2) {
                    margin-left: -14px;
                    background:lighten($yellow-2, 30%);
                }
                &:nth-child(3) {
                    margin-left: -14px;
                    background: lighten($yellow-2, 40%);
                }
            }
        }
    }
    main {
        flex: 1;
        text-align: center;
        margin: 1.5rem 1rem;
        .content {
            display: flex;
            flex-direction: column;
            gap: 16px;
        }
        .qr-code {
            margin: 0 auto;
            flex-shrink: 1;
            margin-bottom: 20px;
            min-height: 60px;
            max-height: 130px;
            transition: height 400ms ease-in-out;
            align-content: center;
            
            .image {
                height: 100%;
                // width: 150px;
                &::v-deep {
                    canvas {
                        height: 100% !important;
                        width: 100% !important;
                    }
                }
            }
            &.h-hidden {
                height: 0 !important;
            }
        }
    }
    @media screen and (((max-width: $mobile-breakpoint) and (orientation: portrait)) or ((max-height: 680px) and (orientation: landscape))) {
        flex-direction: column;

        aside {
            flex-basis: 32%;
            overflow: hidden;
            .content {
                padding: 0;
                ul li {
                    line-height: 1.4;
                    margin-bottom: 8px;
                }
            }
            .social-proof {
                margin-left: 10px;
                line-height: 1;
                .user-block {
                    margin-left: -18px;
                }
            }
        }
        main {
            padding: 0;
            .maintitle {
                display: none;
            }
        }
        .phone-icon-blob,
        ul {
            display: none;
        }
        .maintitle {
            font-size: 1.5rem;
        }
    }
    .sms-container {
        // height: 0;
        transition: height 400ms ease-in-out;
    }
}
@keyframes float {
  0% { transform: translateY(0px) rotate(6deg); }
  50% { transform: translateY(-10px) rotate(8deg); }
  100% { transform: translateY(0px) rotate(6deg); }
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes borderPulse {
  0%, 100% { opacity: 0.8; }
  50% { opacity: 0.4; }
}

.floaty-bit {
    position: absolute; 
    &.bit-1 {
        left: 0px; 
        top: 0px; 
        height: 16rem; 
        width: 16rem; 
        transform: translate(0, -50%) rotate(0) skewX(0) skewY(0) scaleX(1) scaleY(1); 
        border-radius: 9999px; 
        background-color: rgb(255,255,255); 
        opacity: 0.1;
    }
    &.bit-2 {
        bottom: 0px; 
        right: 0px; 
        height: 12rem; 
        width: 12rem; 
        transform: translate(0, 33.333333%) rotate(0) skewX(0) skewY(0) scaleX(1) scaleY(1); 
        border-radius: 9999px; 
        background-color: rgb(255,255,255); 
        opacity: 0.1;
    }
    &.bit-3 {
        right: 0px; 
        top: 50%; 
        height: 8rem; 
        width: 8rem; 
        transform: translate(50%, 0) rotate(0) skewX(0) skewY(0) scaleX(1) scaleY(1); 
        border-radius: 9999px; 
        background-color: rgb(255,255,255); 
        opacity: 0.05;
    }
    &.bit-4 {
        right: 25%; 
        top: 25%; 
        height: 5rem; 
        width: 4rem; 
        transform: translate(0, 0) rotate(0) skewX(0) skewY(0) scaleX(1) scaleY(1); 
        border-radius: 0.375rem; 
        background-color: rgb(255,255,255); 
        opacity: 0.6; 
        box-shadow: 0 0 #0000, 0 0 #0000, 0 10px 15px -3px rgb(0,0,0,0.1), 0 4px 6px -4px rgb(0,0,0,0.1);
    }
    .bit-wrap {
        height: 75%; 
        width: 100%; 
        overflow: hidden; 
        border-top-left-radius: 0.375rem; 
        border-top-right-radius: 0.375rem; 
        background-color: rgb(229,231,235);
        .bit-inner {
            width: 100%; 
            height: 100%; 
            background-image: linear-gradient(to bottom right, $yellow-1); 
            background-color: #FEF3C7; 
        }
    }
}

.animate-float {
  animation: float 6s ease-in-out infinite;
}

.animate-fadeIn {
  animation: fadeIn 0.8s ease-out forwards;
}

.animate-borderPulse {
  animation: borderPulse 2s ease-in-out infinite;
}
.cta {
    display: flex; 
    padding-top: 1rem;
    padding-bottom: 1rem; 
    padding-left: 1.25rem;
    padding-right: 1.25rem; 
    justify-content: center; 
    align-items: center; 
    border-radius: 0.75rem; 
    border-width: 1px; 
    border-color: #D1D5DB; 
    background: linear-gradient(146deg, rgba(255, 115, 0, 1) 0%, rgba(255, 59, 0, 1) 100%);
    font-size: 1.125rem;
    line-height: 1.75rem; 
    font-weight: 500; 
    font-weight: bold;
    color: white; 
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 300ms; 

    &:hover {
        background-color: #F9FAFB; 
    }

}
.h-hidden {
    height: 0px !important;
    overflow: hidden;
    transition: height 400ms ease-in-out;
}
.ctas {
    display: flex;
    flex-direction: column;
    padding-top: 20px;
    margin-bottom: -20px;
}
</style>
